
import { MasterDataContainer } from '../../dataAccess/masterDataContainer';
import { KmkInfoCacheViewModel } from './kmkInfoCacheViewModel';

export class KmkInfoCacheContainer extends MasterDataContainer<KmkInfoCacheViewModel> {
    constructor(models: Array<KmkInfoCacheViewModel>, dataYear: number, version: Date) {
        super(models, dataYear, version);
    }
}
